import React from 'react';

const Header = () => {
  return (
    <header className="py-6">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-800 mb-2">Anujkumarsinh Donvir</h1>
        <h1 className="text-2xl font-bold text-gray-800 mb-2">Tech Lead | IEEE Senior Member | Speaker | Mentor | Technical Writer & Author</h1>
        <div className="m2-4">
          <p className="text-lg text-gray-600">
            <span>LinkedIn:  <a href="https://www.linkedin.com/in/anuj-donvir/" target="_blank" className="text-blue-500 hover:underline">Anuj Donvir</a></span>
            <span  className="ml-2">Email: <a href="mailto:your.email@example.com" className="text-blue-500 hover:underline">anujdonvir@gmail.com</a></span>
            
          </p>
          <p className="text-lg text-gray-600">
            Phone: <a href="tel:+1234567890" className="text-blue-500 hover:underline">+12014647182</a>
          </p>
          <p className="text-lg text-gray-600 block sm:hidden">
            <a
              href="/anujkumarsinh_donvir.pdf"
              download
              className="text-blue-500 hover:underline px-4 py-2"
            >
              Download Resume
            </a>
          </p>
        </div>
      </div>
    </header>
  )
}

export default Header;